import makeApiRequest from './makeApiCall';

export const getStatementOfChangesInEquityReport = async (params) => {
  return await makeApiRequest(
    '/statement-of-changes-in-equity-report',
    'POST',
    null,
    params,
  );
};

export const exportStatementOfChangesInEquityReport = async (params) => {
  return await makeApiRequest(
    '/statement-of-changes-in-equity-report/export',
    'POST',
    null,
    params,
  );
};
